import { useLazyGetBanksForAutocompleteQuery } from "../api/Banks";

export function useGetBanksForAutocomplete() {
  const [
    triggerBanksFetching,
    { data, isError, isFetching, isLoading },
  ] = useLazyGetBanksForAutocompleteQuery();

  return {
    banks: data?.banks ?? [],
    isBanksError: isError,
    isBanksFetching: isFetching,
    isBanksLoading: isLoading,
    totalItems: data?.totalItems ?? 0,
    triggerBanksFetching,
  };
}
